var objects = [];
module.exports = objects;



/*****************
 ** WEBPACK FOOTER
 ** ./js/objects.js
 ** module id = 1
 ** module chunks = 0
 **/